// @flow

import React, { Component } from 'react'
import { Layout, VideoHeader, Caption, BodyTitle, Logo } from './Sections'

type VideoContentProps = {
  title: string,
  logoUrl: string,
  caption: ?string,
  fileUrl: string,
  thumbnail: ?string,
  isAudio: boolean,
  hlsVideoPlaylistUrl: ?string,
  hashtags: string[]
}
type VideoContentState = {
  loaded: boolean
}

class VideoContent extends Component <VideoContentProps, VideoContentState> {
  UNSAFE_componentWillMount () {
    this.setState({ loaded: false })
  }

  componentDidMount () {
    this.setState({ loaded: true })
  }

  getHeader () {
    const { thumbnail, fileUrl, isAudio, hlsVideoPlaylistUrl } = this.props
    if (thumbnail) {
      return <VideoHeader src={fileUrl} hlsVideoPlaylistUrl={hlsVideoPlaylistUrl} thumbnail={thumbnail} isAudio={isAudio} />
    }

    return (
      <VideoHeader src={fileUrl} hlsVideoPlaylistUrl={hlsVideoPlaylistUrl} isAudio={isAudio} />
    )
  }

  getBody () {
    const { logoUrl } = this.props
    const title = this.getBodyTitle()
    const caption = this.getCaption()

    return (
      <div>
        <Logo src={logoUrl} />
        {title}
        {caption}
      </div>
    )
  }

  getCaption () {
    const { caption, logoUrl, hashtags } = this.props
    if (!caption) {
      return null
    }
    return <Caption usePadding={!logoUrl} caption={caption} hashtags={hashtags} />
  }

  getBodyTitle () {
    const { title } = this.props

    return <BodyTitle title={title} usePadding={false} />
  }

  render () {
    if (!this.state.loaded) {
      return null
    }
    const { logoUrl } = this.props
    const header = this.getHeader()
    const body = this.getBody()
    return (
      <Layout header={header} body={body} usePadding={!logoUrl} useParallax />
    )
  }
}

export default VideoContent
